// src/utils/utmHelper.js

/**
 * Build a URL with preserved UTM parameters from session storage
 * @param {string} baseUrl - The base URL to append UTM parameters to
 * @returns {string} - URL with UTM parameters appended
 */
export const buildUrlWithUTM = (baseUrl) => {
  try {
    const savedUrl = sessionStorage.getItem("url");
    console.log("🔍 Saved URL from sessionStorage:", savedUrl);

    if (!savedUrl) {
      console.log("❌ No saved URL found, returning base URL:", baseUrl);
      return baseUrl;
    }

    const urlObj = new URL(savedUrl);
    const utmParams = new URLSearchParams();

    // Extract UTM parameters from the saved URL
    const utmKeys = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
      "gclid",
      "gbraid",
      "wbraid",
      "fbclid",
    ];

    utmKeys.forEach((key) => {
      const value = urlObj.searchParams.get(key);
      if (value) {
        console.log(`✅ Found UTM parameter: ${key} = ${value}`);
        utmParams.append(key, value);
      }
    });

    // If no UTM parameters found, return original URL
    if (utmParams.toString() === "") {
      console.log("❌ No UTM parameters found, returning base URL:", baseUrl);
      return baseUrl;
    }

    // Append UTM parameters to the base URL
    const finalUrl = new URL(baseUrl);
    utmParams.forEach((value, key) => {
      finalUrl.searchParams.set(key, value);
    });

    const finalUrlString = finalUrl.toString();
    console.log("🎯 Final URL with UTMs:", finalUrlString);

    return finalUrlString;
  } catch (error) {
    console.warn("Error building URL with UTM parameters:", error);
    return baseUrl;
  }
};

/**
 * Navigate to URL with preserved UTM parameters
 * @param {string} baseUrl - The base URL to navigate to
 */
export const navigateWithUTM = (baseUrl) => {
  console.log("🚀 navigateWithUTM called with baseUrl:", baseUrl);

  const urlWithUTM = buildUrlWithUTM(baseUrl);
  console.log("🎯 About to navigate to:", urlWithUTM);

  window.location.assign(urlWithUTM);
};
